import { httpClient } from '@api/interceptors';

export const createFilePublicLink = async (
  objectName: string,
  bucketName: string,
): Promise<string> => {
  return httpClient
    .post(`files/create-public-link`, {
      json: {
        objectName,
        bucketName,
      },
    })
    .text();
};
